import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// IMPORTANT: Replace with your actual Firebase config
const firebaseConfig = {
  apiKey: process.env.REACT_APP_apiKey,
  authDomain: process.env.REACT_APP_authDomain,
  projectId: process.env.REACT_APP_projectId,
  storageBucket: process.env.REACT_APP_storageBucket,
  messagingSenderId: process.env.REACT_APP_messagingSenderId,
  appId: process.env.REACT_APP_appId,
  measurementId: process.env.REACT_APP_measurementId
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { app, auth, db };




// export const auth = {};
// export const db = {};

// export const signInWithEmailAndPassword = () => {};
// export const sendPasswordResetEmail = () => {};
// export const createUserWithEmailAndPassword = () => {};
// export const setDoc = () => {};
// export const doc = () => {};
// export const collection = () => {};
// export const addDoc = () => {};
// export const signOut = () => {};
// export const onAuthStateChanged = () => {};
// export const query = () => {};
// export const where = () => {};
// export const onSnapshot = () => {};
